<template>
    <rkm-form>
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.massa"
                    @change="calcularIMC"
                    @input="handleMassaInput"
                    label="Peso"
                    v-mask="mask.massa"
                    v-model="data.model.avaliacaoAntropometrica.massa"
                >
                    <template slot="append">
                        <rkm-button
                            :color="data.model.avaliacaoAntropometrica.massaUnidadeMedidaId === enums.unidadeMedida.QUILOGRAMAS ? 'secondary' : 'light'"
                            @click="setUnidadeMedida('massa', enums.unidadeMedida.QUILOGRAMAS)"
                        >
                            {{ getUnidadeMedida(enums.unidadeMedida.QUILOGRAMAS).sigla }}
                        </rkm-button>

                        <rkm-button
                            :color="data.model.avaliacaoAntropometrica.massaUnidadeMedidaId === enums.unidadeMedida.GRAMAS ? 'secondary' : 'light'"
                            @click="setUnidadeMedida('massa', enums.unidadeMedida.GRAMAS)"
                        >
                            {{ getUnidadeMedida(enums.unidadeMedida.GRAMAS).sigla }}
                        </rkm-button>
                    </template>
                </rkm-form-input>
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-form-radio-group
                    label="Tipo de altura"
                    v-model="data.model.avaliacaoAntropometrica.alturaTipoMedidaId"
                >
                    <rkm-form-radio :value="enums.tipoMedidaAltura.COMPRIMENTO">
                        Comprimento
                    </rkm-form-radio>

                    <rkm-form-radio :value="enums.tipoMedidaAltura.ESTATURA">
                        Estatura
                    </rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    :validations="validations.altura"
                    @change="calcularIMC"
                    @input="handleAlturaInput"
                    label="Altura"
                    v-mask="mask.altura"
                    v-model="data.model.avaliacaoAntropometrica.altura"
                >
                    <template slot="append">
                        <rkm-button
                            :color="data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId === enums.unidadeMedida.METROS ? 'secondary' : 'light'"
                            @click="setUnidadeMedida('altura', enums.unidadeMedida.METROS)"
                        >
                            {{ getUnidadeMedida(enums.unidadeMedida.METROS).sigla }}
                        </rkm-button>

                        <rkm-button
                            :color="data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId === enums.unidadeMedida.CENTIMETROS ? 'secondary' : 'light'"
                            @click="setUnidadeMedida('altura', enums.unidadeMedida.CENTIMETROS)"
                        >
                            {{ getUnidadeMedida(enums.unidadeMedida.CENTIMETROS).sigla }}
                        </rkm-button>
                </template>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :append="data.model.avaliacaoAntropometrica.imc.classificacao || ''"
                    disabled
                    label="Índice de massa corporal"
                    v-model="data.model.avaliacaoAntropometrica.imc.imc"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Enums.
import unidadeMedida from '@/enums/cadastro/unidadeMedida'
import tipoMedidaAltura from '@/enums/geral/tipoMedidaAltura'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories.geral = this.getConectaSusRepository('geral')
    },
    computed: {
        validations() {
            return {
                altura: { required: false },
                massa: { required: false },
            }
        }
    },
    data: () => ({
        enums: { tipoMedidaAltura, unidadeMedida },
        mask: {
            altura: '###',
            massa: '######',
        },
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleMassaInput(item) {
            const length = item.replace('.', '').length

            if (this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId === this.enums.unidadeMedida.QUILOGRAMAS) {
                if (length <= 3) {
                    this.mask.massa = '#.##'
                }
                else if (length <= 4) {
                    this.mask.massa = '##.##'
                }
                else {
                    this.mask.massa = '###.##'
                }
            } else {
                this.mask.massa = '######'
            }
        },
        handleAlturaInput() {
            if (this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId === this.enums.unidadeMedida.METROS) {
                this.mask.altura = '#.##'
            } else {
                this.mask.altura = '###'
            }
        },
        getUnidadeMedida(id) {
            return this.data.form.unidadesMedida.find(unidade => unidade.id === id)
        },
        setUnidadeMedida(key, destino_id) {
            if(this.data.model.avaliacaoAntropometrica[`${key}UnidadeMedidaId`] == destino_id) return false

            this.$nextTick(() => {
                this.data.model.avaliacaoAntropometrica[`${key}UnidadeMedidaId`] = destino_id
            })
        },
        calcularIMC() {

            if (!this.data.model.avaliacaoAntropometrica.massa || !this.data.model.avaliacaoAntropometrica.altura) {

                this.data.model.avaliacaoAntropometrica.imc.imc = ''
                this.data.model.avaliacaoAntropometrica.imc.classificacao = ''

                return
            }

            this.setLoading()

            this.repositories.geral.calcularIMC({
                unidade_medida_massa_id: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                massa: this.data.model.avaliacaoAntropometrica.massa || 1,
                unidade_medida_altura_id: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                altura: this.data.model.avaliacaoAntropometrica.altura || 1,
            })
                .then(response => {
                    this.data.model.avaliacaoAntropometrica.imc = Object.assign({}, {
                        imc: response.data.imc,
                        classificacao: response.data.classificacao
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true },
    },
    watch: {
        'data.model.avaliacaoAntropometrica.massaUnidadeMedidaId'() {
            this.$nextTick(() => {
                this.data.model.avaliacaoAntropometrica.massa = ''
                this.data.model.avaliacaoAntropometrica.imc.imc = ''
                this.data.model.avaliacaoAntropometrica.imc.classificacao = ''
            })
        },
        'data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId'() {
            this.$nextTick(() => {
                this.data.model.avaliacaoAntropometrica.altura = ''
                this.data.model.avaliacaoAntropometrica.imc.imc = ''
                this.data.model.avaliacaoAntropometrica.imc.classificacao = ''
            })
        },
    },
}
</script>